//@ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import emitter from "src/helpers/emitter";
import { getAssistantEvents, TABLE_ASSISTANT } from "./constants";

import { ChatBot } from "./ChatClass"; // adjust the import path as needed
import { tableGenerationPrompt } from "./prompts";
import TablePreviewComponent from "../worksheet/components/blocks/renderers/AllInOne/renderEditor/ComponentsEditor/GenericTable/preview";
import TablePreviewWrapper from "./preview/TablePreview";
import MessageComponent from "./MessageComponent";

interface Message {
    role: "system" | "user" | "assistant";
    userFacingMessage: string;
    backgroundMessage?: string;
}

const ChatComponent: React.FC = ({ setTableData }: any) => {
    // State to control if chat is open (full screen) or closed (floating icon)
    const [isOpen, setIsOpen] = useState(false);

    const [currentMessageLoadingState, setCurrentMessageLoadingState] =
        useState("");

    // loading state
    const [isLoading, setIsLoading] = useState(false);
    // Array to hold conversation messages
    const [messages, setMessages] = useState<Message[]>([]);
    // The input field state for the user message
    const [input, setInput] = useState("");

    // Use a ref to hold the ChatBot instance (so it persists across renders)
    const chatBotRef = useRef<ChatBot | null>(null);

    // Initialize ChatBot on first render
    useEffect(() => {
        if (!chatBotRef.current) {
            // Replace "Your core prompt" and "modelName" with actual values as needed.
            chatBotRef.current = new ChatBot(
                tableGenerationPrompt,
                process.env.REACT_APP_OPENAI_MODEL || "gpt-4o-2024-08-06",
                "Welcome to the chat!",
            );
        }
    }, []);

    useEffect(() => {
        emitter.on(getAssistantEvents("TABLE").name, (data) => {
            setCurrentMessageLoadingState(data.message);
            console.log("message-------", data.message);
        });
    }, []);

    // Toggle between open and closed states
    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    // Handle sending a message
    const handleSend = async () => {
        if (!input.trim() || !chatBotRef.current) return;
        setIsLoading(true);

        // Add the user message to the ChatBot conversation (with extra info)
        const messageObj = chatBotRef.current.addUserMessage(input);

        setMessages((prev) => [...prev, messageObj]);

        // Clear the input field
        setInput("");

        // Get the assistant's response from ChatBot
        try {
            const response = await chatBotRef.current.getFormattedResponse();

            setMessages((prev) => [...prev, response]);
        } catch (error) {
            console.error("Error getting response:", error);
        } finally {
            setIsLoading(false);
        }
    };

    console.log("messages", messages);

    return (
        <>
            {isOpen ? (
                // Half-screen chat container when open
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "50%",
                        height: "100%",
                        backgroundColor: "#fff",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        borderRight: "1px solid #ddd",
                    }}
                >
                    {/* Chat Header */}
                    <header
                        style={{
                            padding: "10px",
                            backgroundColor: "#eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <h2>
                            Chat - Warning!! Experimental Feature, only works
                            with tables
                        </h2>
                        <button onClick={toggleChat}>Close</button>
                    </header>

                    {/* Chat Conversation Area */}
                    <main
                        style={{
                            flex: 1,
                            padding: "10px",
                            overflowY: "auto",
                        }}
                    >
                        {messages.map((msg, index) => (
                            <MessageComponent
                                key={index}
                                message={msg}
                                setTableData={setTableData}
                                isLoading={
                                    isLoading &&
                                    index === messages.length - 1 &&
                                    msg.role === "assistant"
                                }
                            />
                        ))}
                        {isLoading && (
                            <MessageComponent
                                message={{
                                    role: "assistant",
                                    extra: {
                                        userFacingMessage:
                                            currentMessageLoadingState,
                                    },
                                }}
                                isLoading={true}
                                setTableData={setTableData}
                            />
                        )}
                    </main>

                    {/* Chat Input Area */}
                    <footer
                        style={{
                            padding: "10px",
                            borderTop: "1px solid #ddd",
                        }}
                    >
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            style={{ width: "80%", padding: "10px" }}
                            placeholder="Type your message..."
                        />
                        <button
                            onClick={handleSend}
                            disabled={isLoading}
                            style={{ padding: "10px", marginLeft: "10px" }}
                        >
                            {isLoading ? "Sending..." : "Send"}
                        </button>
                    </footer>
                </div>
            ) : (
                // Floating chat icon at bottom-right when chat is closed
                <div
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "20px",
                        zIndex: 1000,
                    }}
                >
                    <button
                        onClick={toggleChat}
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "#007bff",
                            color: "#fff",
                            border: "none",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                            cursor: "pointer",
                        }}
                    >
                        Chat
                    </button>
                </div>
            )}
        </>
    );
};

export default ChatComponent;
